import React from 'react'

const Details = ({ data: { details}, client }) => {

    const mode = {
        'INT_OCEAN': 'Ocean',
    }

    if (details) {
        let modeFriendly = mode[details.mode] || details.mode 
        
        let povalue = null
        if (details.value && client === 'kwiktrip') {
            try {
                const po_value = details.value  // assuming this is a float

                const formatted = new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
                }).format(po_value)

                povalue = formatted !== '0' ? formatted : null
            } catch (error) {
                console.error('Error formatting value:', error)
                povalue = null
            }
        }



        return (
            <div style={{ fontSize: '0.875rem', lineHeight: '1.6' }}>
                {details.mode ? <div><strong>Mode:</strong> {modeFriendly}</div> : null}
                {details.equipment.length ? <div><strong>Equip:</strong> {details.equipment}</div> : null}
                {details.miles ? <div><strong>Miles:</strong> {details.miles}</div> : null}
                {details.totalWeight ? <div><strong>Weight:</strong> {details.totalWeight} lbs</div> : null}
                {details.feet ? <div><strong>Feet:</strong> {details.feet}</div> : null}
                {povalue ? <div><strong>Value:</strong> ${povalue}</div> : null}
            </div>
        )
    } else {
        return null
    }
}

export default Details